const store = {
  images: [
    {
      image: "/images/yogo.jpg",
      title: "yogo"
    },
    {
      image: "/images/bar.jpg",
      title: "bar"
    },
    {
      image: "/images/basketball.jpg",
      title: "basketball"
    },
    {
      image: "/images/beach_summer.jpg",
      title: "beach"
    },
    {
      image: "/images/book_fall.jpg",
      title: "book"
    },
    {
      image: "/images/car.jpg",
      title: "car"
    },
    {
      image: "/images/cat_fall.jpg",
      title: "cat"
    },
    {
      image: "/images/coffee_swirls.jpg",
      title: "coffee swirls"
    }
    //{
    //  image: "/images/coffee_shop.jpg",
    //  title: "coffee shop"
    //}
    //{
    //  image: "/images/dark_alley.jpg",
    //  title: "dark alley"
    //},
    //{
    //  image: "/images/dog.jpg",
    //  title: "dog"
    //},
    //{
    //  image: "/images/dry_van.jpg",
    //  title: "dry van"
    //},
    //{
    //  image: "/images/to_east.jpg",
    //  title: "to east"
    //},
    //{
    //  image: "/images/ttc_winter.jpg",
    //  title: "ttc winter"
    //},
    //{
    //  image: "/images/winter_contrast.jpg",
    //  title: "winter contrast"
    //}
  ],

  icons: [
    {
      icon: "/icons/facebook_icon-color.svg",
      title: "facebook"
    },
    {
      icon: "/icons/twitter_icon-color.svg",
      title: "twitter"
    },
    {
      icon: "/icons/linkedin_icon-color.svg",
      title: "linkedin"
    },
    {
      icon: "/icons/instagram_icon-color.svg",
      title: "instagram"
    },
    {
      icon: "/icons/google-plus_icon-color.svg",
      title: "google"
    },
    {
      icon: "/icons/pinterest_icon-color.svg",
      title: "pintrest"
    },
    {
      icon: "/icons/tumblr_icon-color.svg",
      title: "tumblr"
    },
    {
      icon: "/icons/soundcloud_icon-color.svg",
      title: "soundcloud"
    }
  ],
  components: {
    vibrantButtons: [
      {
        palette: 'Vibrant',
        paletteBackground: 'LightVibrant'
      },
      {
        palette: 'DarkVibrant',
        paletteBackground: 'LightVibrant'
      },
      {
        palette: 'Muted',
        paletteBackground: 'LightVibrant'
      },
      {
        palette: 'DarkMuted',
        paletteBackground: 'LightVibrant'
      },
    ],
    mutedButtons: [
      {
        palette: 'Vibrant',
        paletteBackground: 'LightMuted'
      },
      {
        palette: 'DarkVibrant',
        paletteBackground: 'LightMuted'
      },
      {
        palette: 'Muted',
        paletteBackground: 'LightMuted'
      },
      {
        palette: 'DarkMuted',
        paletteBackground: 'LightMuted'
      },
    ],
  }
}

export default store;